import React from "react";

const HandGloves = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M31.481 17.487a1.89 1.89 0 0 0-2.612-.326l-3.89 2.745c.103-2.276 1.2-12.328 1.397-13.54a1.856 1.856 0 0 0-.3-1.353 1.817 1.817 0 0 0-1.147-.757 1.761 1.761 0 0 0-1.337.194c-.403.24-.697.63-.817 1.087-.968 3.554-1.562 6.515-2.301 9.995-.09-1.544-.243-4.026-.396-6.484-.113-1.813-.22-3.614-.305-5.02-.22-2.803-4.305-2.655-4.314.165.035 2.608.199 9.793.215 11.87.02.094-.2.133-.203.023-.682-2.06-2.472-7.883-3.212-10.166a1.915 1.915 0 0 0-.907-1.079 1.88 1.88 0 0 0-1.392-.156c-.467.13-.868.434-1.12.851a1.94 1.94 0 0 0-.238 1.396c.7 3.137 1.607 6.899 2.238 9.943.133.345-.16-.01-.271-.148-1.064-1.442-2.357-3.287-3.449-4.786a1.688 1.688 0 0 0-2.312-.423c-1.482.98-.608 2.352.113 3.62 1.42 2.658 3.788 7.112 4.834 9.61.87 2.11 1.837 4.93 1.543 7.983-.017.506-.02 1.244.617 1.269h12.392a.562.562 0 0 0 .534-.394.58.58 0 0 0 .026-.235c-.543-5.735 1.588-7.976 5.127-11.693 1.072-1.152 2.909-2.49 1.487-4.19Zm-17.3 14.226a.568.568 0 0 1-.402-.157.581.581 0 0 1-.18-.398 20.596 20.596 0 0 0-1.758-7.296.576.576 0 0 1 .303-.746.558.558 0 0 1 .737.306 21.715 21.715 0 0 1 1.849 7.702.575.575 0 0 1-.333.54.557.557 0 0 1-.215.049Z"
            fill={fill}
        />
    </svg>
);

export default HandGloves;